import { render, staticRenderFns } from "./pendingByUser.vue?vue&type=template&id=2d0a0061&"
import script from "./pendingByUser.vue?vue&type=script&lang=js&"
export * from "./pendingByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports